export class AdminGrowthInvestmentPerformance {
  key = ""

  investmentAmount = 0

  associatedRevenueAmount = 0

  leadsCount = 0

  conversionsCount = 0

  acquiredCustomersCount = 0

  profitOrLossAmount = 0

  roiPercentage = 0

  constructor(data: Partial<AdminGrowthInvestmentPerformance> = {}) {
    Object.assign(this, data)
  }
}
